<template>
    <div>
        <el-carousel :height="computeHeight" style="margin-top: 10px;margin-bottom: 10px;">
            <el-carousel-item v-for="(item, index) in sliders" :key="index">
                <img :src="item.img" class="slider_img">
            </el-carousel-item>
        </el-carousel>
        
        <!-- 手机端商品展示 -->
        <div id="产品介绍" class="head-label" style="margin-top: 30px;">
            <div style="text-align: center;" class="font_size_24">
                产品介绍
            </div>
        </div>
        <div class="product_mobile">
            <el-row>
                <el-col :xs="24" :sm="12">
                    <div class="product_mobile_content" style="padding-top: 50%;position: relative;">
                        <div style="position: absolute;left: 0;top: 0;right: 0;bottom: 0;display: flex;
                        justify-content: center;align-items: center;flex-direction: column;">
                            <div class="product_mobile_title font_size_30">{{products[0].title}}</div>
                            <div class="product_font_style product_mobile_content_one" v-for="(content, index) in products[0].content" :key="index">{{content}}</div>
                        </div>
                    </div>
                </el-col>
				<el-col :xs="24" :sm="12">
				    <div class="product_mobile_content" style="padding-top: 50%;position: relative;">
				        <div style="position: absolute;left: 0;top: 0;right: 0;bottom: 0;display: flex;
				        justify-content: center;align-items: center;flex-direction: column;">
				            <img :src="products[0].img[0].left" style="width: 40%;">
				        </div>
				    </div>
				</el-col>
            </el-row>
			
		
			
			
			
			<el-row>
			    <el-col :xs="24" :sm="12">
			        <div class="product_mobile_content" style="padding-top: 50%;position: relative;">
			            <div style="position: absolute;left: 0;top: 0;right: 0;bottom: 0;display: flex;
			            justify-content: center;align-items: center;flex-direction: column;">
			                <div class="product_mobile_title font_size_30">{{products2[0].title}}</div>
			                <div class="product_font_style product_mobile_content_one" v-for="(content, index) in products2[0].content" :key="index">{{content}}</div>
			            </div>
			        </div>
			    </el-col>
				<el-col :xs="24" :sm="12">
				    <div class="product_mobile_content" style="padding-top: 50%;position: relative;">
				        <div style="position: absolute;left: 0;top: 0;right: 0;bottom: 0;display: flex;
				        justify-content: center;align-items: center;flex-direction: column;">
				            <img :src="products2[0].img[0].left" style="width: 40%;">
				        </div>
				    </div>
				</el-col>
			</el-row>
			
			<el-row>
			    <el-col :xs="24" :sm="12">
			        <div class="product_mobile_content" style="padding-top: 50%;position: relative;">
			            <div style="position: absolute;left: 0;top: 0;right: 0;bottom: 0;display: flex;
			            justify-content: center;align-items: center;flex-direction: column;">
			                <div class="product_mobile_title font_size_30">{{products3[0].title}}</div>
			                <div class="product_font_style product_mobile_content_one" v-for="(content, index) in products3[0].content" :key="index">{{content}}</div>
			            </div>
			        </div>
			    </el-col>
				<el-col :xs="24" :sm="12">
				    <div class="product_mobile_content" style="padding-top: 50%;position: relative;">
				        <div style="position: absolute;left: 0;top: 0;right: 0;bottom: 0;display: flex;
				        justify-content: center;align-items: center;flex-direction: column;">
				            <img :src="products3[0].img[0].left" style="width: 40%;">
				        </div>
				    </div>
				</el-col>
			</el-row>
			
        </div>
        
        <!-- 关于我们-->
        <div id="关于我们" class="about_me head-label">
            <div style="text-align: center;" class="font_size_24">
                关于我们
            </div>
        </div>
        <div style="width: 90%;margin: 10px auto;">
           <!-- <div style="display: flex; flex-direction: column;width: 100%;">
				<div>产品来源：</div>
                <p class="about_me_p">{{company[0]}}</p>
            </div> -->
			<div style="display: flex; flex-direction: column;width: 100%;">
				<!-- <div>联系方式：</div> -->
			    <p class="about_me_p"> 邮箱：2171254906@qq.com</p>
			</div>
        </div>

    </div>
</template>
<script>
    export default {
        name: 'Index',
        data() {
            return {
                sliders: [],
                images: [
                    {
                        title: "用户管理",
                        content: ["用户消费分析", "用户标签设定"]
                    },
                    {
                        title: "功能多",
                        content: ["店铺模板切换", "店铺商品上架"]
                    },
                    {
                        title: "数据分析",
                        content: ["交易量直观分析", "经营效果智能分析"]
                    }, {
                        title: "用户互动",
                        content: ["营销活动通知", "用户粘连度提升"]
                    },
                    {
                        title: "品牌渠道",
                        content: ["打造店铺自主品牌", "品牌多样化管理"]
                    }
                ],
                products: [
                    {
                        img: [
                            {
                                left: require('../../static/other/1.jpg'), 
                            }
                        ],
                        title: "首页",
                        content: [
                            "归零软件是一款记录生活软件，主要是记录人与生活的信息", 
                            "主要包括人生大事件、愿望、执念、关系、人情往来、实物",
                            "资产、虚拟资产等内容"
                        ]
                    }
                ],
				products2: [
				    {
				        img: [
				            {
				                left: require('../../static/other/2.jpg'), 
				            }
				        ],
				        title: "感情",
				        content: [
				            "感情模块聚焦于记录和管理您的内心世界，涵盖", 
				            "愿望、执念、关系、对他说、人情往来、时光",
							"胶囊六大功能，全方位留存您的情感与精神思绪"

				        ]
				    }
				],
				products3: [
				    {
				        img: [
				            {
				                left: require('../../static/other/3.jpg'), 
				            }
				        ],
				        title: "财富",
				        content: [
				            "财富模块专注于管理您的各类数字资产与财务信息，", 
				            "包含资金、信用卡、充值卡、投资理财、债务、其他，",
				        	"帮助您全面掌控个人财务状况，实现财务的有序管理"
				        
				        ]
				    }
				],
				products4: [
				    {
				        img: [
				            {
				                left: require('../../static/other/xiaolv.jpg'), 
				            }
				        ],
				        title: "效率",
				        content: [
				            "效率主要包括事项、习惯、目标", 
				            "自律起来，搞钱更容易！"
				        ]
				    }
				],
				products5: [
				    {
				        img: [
				            {
				                left: require('../../static/other/jilu.jpg'), 
				            }
				        ],
				        title: "记笔记",
				        content: [
				            "记笔记主要包括日记、记心情、备忘录", 
				            "记录让变老的过程不无聊！"
				        ]
				    }
				],
				products6: [
				    {
				        img: [
				            {
				                left: require('../../static/other/jiankang.jpg'), 
				            }
				        ],
				        title: "记健康",
				        content: [
				            "记健康主要包括记体重、记体围、记生理期", 
				            "记录健康，让自己更自信！"
				        ]
				    }
				],
				products7: [
				    {
				        img: [
				            {
				                left: require('../../static/other/zhanghu.jpg'), 
				            }
				        ],
				        title: "记账户",
				        content: [
				            "记账户主要包括记账户、记银行卡、记地址", 
				            "记账户，告别满世界找密码！"
				        ]
				    }
				],
				products8: [
				    {
				        img: [
				            {
				                left: require('../../static/other/jinianri.jpg'), 
				            }
				        ],
				        title: "纪念日",
				        content: [
				            "记录美好的日子！", 
				        ]
				    }
				],
				products9: [
				    {
				        img: [
				            {
				                left: require('../../static/other/tongxulu.jpg'), 
				            }
				        ],
				        title: "换机备份",
				        content: [
				            "换机再也不怕丢通讯录了！"
				        ]
				    }
				],
                manages: [
                    {
                        img: [require('../../static/other/product_info.jpg')],
                        title: "小程序+公众号一体化微信商城管理平台",
                        content: ["公众号菜单自定义发布 微信图文图片素材管理", "商品多规格SKU自定义上架 分类自定义设置",
                            "用户管理 用户自定义标签，了解用户消费行为",
                            "订单管理 实时掌握商品交易详情", "物流闪电发货 实时掌握物流追踪状态",
                        ]
                    }
                ],
                spec: {
                    img: require('../../static/other/arrow.png'),
                    product: [
                        {
                            img: require('../../static/other/手指.png'),
                            title: "一键建铺",
                            contents: ["注册一键创建店铺", "开启您的专属店铺"]
                        },
                        {
                            img: require('../../static/other/店铺管理.png'),
                            title: "店铺装扮",
                            contents: ["不同业态打造不同风格", "给用户流畅的视觉体验"]
                        },
                        {
                            img: require('../../static/other/数据分析.png'),
                            title: "营销分析",
                            contents: ["多玩法提升品牌知名度", "优惠福利刺激付费转化"]
                        },
                        {
                            img: require('../../static/other/助力零售.png'),
                            title: "助力零售",
                            contents: ["提供专业产品服务", "帮助线下零售业态提升营销"]
                        }
                    ]
                },
                company: [
                    "归零最初的想法只是为了帮我老婆记录一些日常的碎片信息，市面上的app有很多，但是需要下载多个软件才行，她嫌烦，索性就帮她做一个。因此，我和我老婆的关系就变成了甲乙方的关系。随着甲方的需求越来越离谱，归零的内容也慢慢变多！有一天，我老婆说，归零不是她一个人的归零，她希望把归零变成大家老婆的归零，就这样归零就和大家见面了。",
                ],
                carousel_height: '550px',
            }
        },
        methods: {},
        mounted() {
			
            this.sliders = [
                {
                    img: require("../../static/slider/11.jpg")
                },
                // {
                //     img: require("../../static/slider/a2.jpg")
                // },
                // {
                //     img: require('../../static/slider/a3.jpg')
                // },
                // {
                //     img: require('../../static/slider/a4.jpg')
                // }
            ]
        },
        computed: {
            //计算高度
            computeHeight() {
                let screenHeight = document.body.clientWidth;
				
                if (screenHeight > 415) {
                    return '550px';
                } else {
                    return '250px';
                }
            },
            computeArrowImg() {
                let screenHeight = document.body.clientWidth;
                if (screenHeight > 450) {
                    return require('../../static/other/arrow.png');
                } else {
                    return require('../../static/other/arrow_down.png');
                }
            }

        },
    }
</script>

<style scoped>
    .border_parent {
        width: 90%;
        margin: auto;
    }

    .slider_img {
        height: 548px;
        width: 100%;
		border-radius: 10px;
		/* margin-left: 5%;
		border: 1px solid #ccc; */
		
    }

    .solve {
        margin-top: 30px;
        margin-bottom: 10px
    }

    .border {
        border-radius: 6px;
        border: 1px solid #EBEEF5;
        height: auto;
        margin: 10px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
    }

    .border_one {
        margin-left: 0;
    }

    .border_img_parent {
        margin-top: 20px;
        display: flex;
        justify-content: center;
    }

    .product_mobile_content {
        height: 300px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }

    .product_mobile_img {
        width: 50%;
    }

    .product_mobile_title {
        font-weight: bold;
        text-align: center;
    }

    .product_pc_one {
        text-align: center;
        min-height: 400px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .font_size_30 {
        font-size: 1.875em;
    }

    .product_font_style {
        font-size: 1.125em;
    }

    .product_pc_img {
        width: 100%
    }

    .product_pc_img_div {
        width: 50%;
        float: left;
        display: flex;
        align-items: center;
    }

    .product_pc {
        display: flex;
        width: 90%;
        margin: 20px auto;
        background: #F2F6FC;
        align-items: center;
    }

    .product_spec_title {
        margin-top: 30px;
        margin-bottom: 10px
    }

    .product_spec_parent {
        display: flex;
        width: 90%;
        margin: 20px auto;
        align-items: center;
        height: auto
    }

    .cooperation_parent {
        display: flex;
        justify-content: center;
        width: 90%;
        margin: 20px auto;
        align-items: center;
        height: auto
    }

    .border_spec {
        border-radius: 6px;
        border: 1px solid #EBEEF5;
        float: left;
        width: 25%;
        height: auto;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }

    .about_me_p {
        /* font-size: 1.25em; */
        /* font-weight: normal; */
        padding: 0 20px;
        margin: 10px;
    }

    .border_title {
        font-family: "PingFang SC";
        margin-top: 10px;
        font-size: 1.125em;
        font-weight: bold;
        text-align: center;
    }

    .border_content_one {
        margin-top: 20px;
        font-size: 1.125em;
        text-align: center;
    }

    .border_content_two {
        margin-top: 5px;
        font-size: 1.125em;
        margin-bottom: 25px;
        text-align: center;
    }

    .img_border {
        margin-top: 15px;
        width: 80px;
        height: 80px
    }

    .border_spec_inner_one {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 35px;
        height: 70px;
    }

    .border_spec_content_one {
        margin-top: 15px;
        font-size: 1.125em;
        float: left;
        text-align: center;
    }

    .border_spec_inner_last {
        margin-top: 15px;
        font-size: 1.125em;
        float: left;
        margin-bottom: 25px;
        text-align: center;
    }

    .cooperation {
        margin-top: 30px;
        width: 100%;
    }

    .about_me {
        display: flex;
        margin-top: 30px;
        justify-content: center;
        width: 100%;
    }

    .product_mobile {
        width: 90%;
        align-items: center;
        margin: 20px auto;
        /* background: #F2F6FC; */
		
    }

    .product_mobile_img_div {
        width: 50%;
        height: auto;
    }

    .product_mobile_content_one {
        margin-top: 20px;
        text-align: center;
    }

    .product_mobile_content_two {
        margin-top: 10px;
        text-align: center;
    }

    /* 屏幕设备适配 max-device-width: 400px */
    @media screen and (max-device-width: 415px) {
        .slider_img {
            height: 250px;
            width: 100%;
        }


        .border_parent {
            display: flex;
            width: 90%;
            margin: auto;
            height: auto;
            flex-direction: column;
        }

        .border {
            border-radius: 6px;
            border: 1px solid #EBEEF5;
            float: left;
            width: 100%;
            height: auto;
            margin: 10px 0 auto;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
            /*background: aquamarine;*/
        }

        .border_img_parent {
            margin-top: 0;

        }

        .product_mobile {
            width: 90%;
            align-items: center;
            margin: 20px auto;
            height: auto;
            background: #F2F6FC;
        }

        .product_mobile_content {
            width: 100%;
            margin-top: 15px;
        }

        .product_mobile_content_one {
            margin-top: 5px;
        }

        .product_mobile_content_two {
            margin-top: 5px;
        }

        .product_mobile_img_div {
            display: flex;
            width: 100%;
            height: auto;
            justify-content: center;
            margin-top: 10px;
            margin-bottom: 15px;
        }

        .product_mobile_img {
            float: left;
        }

        .product_mobile_title {
            font-weight: bold;
        }

        .product_pc_one {
            width: 100%;
            margin-top: 15px;
        }

        .font_size_30 {
            font-size: 1.25em;
        }

        .product_font_style {
            font-size: 1em;
        }

        .product_pc_img {
            height: 280px;
            width: 320px;
        }

        .product_pc_img_div {
            width: 100%;
            float: left;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 15px;
        }

        .product_pc {
            display: flex;
            width: 90%;
            height: auto;
            margin: 20px auto;
            background: #F2F6FC;
            flex-direction: column;
        }

        .head-label {
            display: flex;
            margin-top: 10px;
        }

        .product_spec_parent {
            display: flex;
            width: 90%;
            align-items: center;
            justify-content: center;
            margin: 20px auto;
            height: auto;
            flex-direction: column;
        }

        .border_spec {
            float: left;
            height: auto;
            margin: 8px;
            width: 100%;
            border-radius: 6px;
            border: 1px solid #EBEEF5;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        }


        .border_title {
            font-family: "PingFang SC";
            margin-top: 5px;
            font-size: 1.125em;
            font-weight: bold;
        }

        .border_content_one {
            margin-top: 5px;
            font-size: 1.125em;
        }

        .border_content_two {
            margin-top: 5px;
            font-size: 1.125em;
            margin-bottom: 8px;
        }

        .img_border {
            margin-top: 8px;
            width: 80px;
            height: 80px
        }

        .border_spec_inner_one {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 8px;
            /*background-color: aqua;*/
            height: 70px;
        }

        .border_spec_content_one {
            margin-top: 5px;
            font-size: 1.125em;
            float: left;
        }

        .border_spec_inner_last {
            /*background-color: bisque;*/
            margin-top: 5px;
            font-size: 1.125em;
            float: left;
            margin-bottom: 8px;
        }

        .about_me {
            display: flex;
            margin-top: 10px;
            width: 100%;
        }
    }

    .border_spec_img {
        width: 75px;
        height: 55px;
        align-self: center
    }

    .font_size_24 {
        font-size: 1.5em;
    }
</style>